import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `retryWorkflowStep`. */
const StepRetryNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="WORKFLOW_STEP_RETRIED"
				title="Étape relancée"
				message="Le traitement reprendra dans quelques instants."
			/>
			<ErrorNotification
				eventName="WORKFLOW_STEP_RETRY_FAILED"
				title="Erreur"
				message="Cette étape n'a pas pu être relancée."
			/>
		</React.Fragment>
	);
};

export default StepRetryNotifications;
